import React from 'react';
import { useFormikContext } from 'formik';

import { useStyles } from '~/assets/styles';
import CheckboxFormik from '~/components/CheckboxFormik';
import List from '~/components/core/Atomic/List';
import ListItem from '~/components/core/Atomic/ListItem';
import ListItemText from '~/components/core/Atomic/ListItemText';
import Text from '~/components/core/TextComponents/Text';

interface FormValues {
  include_parent_attachments?: boolean;
}

interface AttachmentForwardingPreviewProps {
  attachments: Array<{
    file_name: string;
    stored_file?: {
      file_size?: number;
    };
  }>;
}

interface AttachmentForwardingSectionProps {
  attachments: Array<{
    file_name: string;
    stored_file?: {
      file_size?: number;
    };
  }>;
}

const AttachmentForwardingPreview: React.FC<AttachmentForwardingPreviewProps> = ({ attachments }) => {
  return (
    <div style={{ marginLeft: '32px', marginTop: '8px' }}>
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        <strong>Attachments to forward:</strong>
      </Text>
      <List dense style={{ paddingTop: '4px' }}>
        {attachments.map((attachment, index) => (
          <ListItem key={index} style={{ paddingLeft: '0', paddingTop: '2px', paddingBottom: '2px' }}>
            <ListItemText
              primary={attachment.file_name}
              secondary={
                attachment.stored_file?.file_size ? `${(attachment.stored_file.file_size / 1024).toFixed(1)} KB` : ''
              }
              primaryTypographyProps={{ variant: 'body2' }}
              secondaryTypographyProps={{ variant: 'caption' }}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

const AttachmentForwardingSection: React.FC<AttachmentForwardingSectionProps> = ({ attachments }) => {
  const { values } = useFormikContext<FormValues>();
  const { classes } = useStyles();

  return (
    <div className={classes.inputContainer}>
      <CheckboxFormik
        id="include_parent_attachments"
        label={`Include original attachments (${attachments.length} files)`}
      />
      {values.include_parent_attachments && <AttachmentForwardingPreview attachments={attachments} />}
    </div>
  );
};

export default AttachmentForwardingSection;
